import React from 'react';
import Skeleton from 'react-loading-skeleton';

const AvtaleGiroItemSkeleton = () => {
    return (
        <div>
            {Array.from(Array(3)).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={index} className="avtalegiro-list-skeleton__list-element">
                    <div className="avtalegiro-list-skeleton__line">
                        <Skeleton height={25} borderRadius={20} />
                    </div>
                    <Skeleton height={36} width={36} borderRadius={100} />
                </div>
            ))}
        </div>
    );
};

export default AvtaleGiroItemSkeleton;
